'use client'

import { usePathname, useRouter, useSearchParams } from 'next/navigation'

export const registerPage = '/auth/register'
export const loginPage = '/auth/login'

const styles = {
  activeClasses: 'bg-pop-blue-50 !text-pop-blue-700',
  btnClasses: 'flex-1 px-4 py-2.5 shadow-sm text-pop-grey-500 font-medium text-md',
}

const FormTab = () => {
  const pathname = usePathname()
  const router = useRouter()
  const searchParams = useSearchParams()

  const onClick = (path: typeof registerPage | typeof loginPage) => {
    const queryString = searchParams.toString()

    const url = queryString ? `${path}?${queryString}` : path

    router.push(url, { scroll: false })
  }

  return (
    <div className='flex'>
      <button
        type='button'
        onClick={() => onClick(loginPage)}
        className={`
        rounded-bl-lg rounded-tl-lg 
        ${styles.btnClasses} 
        ${pathname === loginPage ? styles.activeClasses : ''}`}
      >
        Login
      </button>
      <button
        type='button'
        onClick={() => onClick(registerPage)}
        className={`
        rounded-br-lg rounded-tr-lg  
        ${styles.btnClasses}
        ${pathname === registerPage ? styles.activeClasses : ''}`}
      >
        Register
      </button>
    </div>
  )
}

export default FormTab
